import { Loader as Loader$1 } from "../loader/Loader.js";
import overlay_module_default from "./overlay.module.js";
import { Overlay } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/overlay/Overlay.tsx
const Overlay$1 = ({ fullScreen = true, loader = false, visible = false, "data-testid": testId }) => {
	if (!visible) return null;
	return /* @__PURE__ */ jsx(Overlay, {
		classNames: overlay_module_default,
		center: true,
		fixed: fullScreen,
		"data-testid": testId,
		children: loader ? /* @__PURE__ */ jsx(Loader$1, { color: "white" }) : null
	});
};

//#endregion
export { Overlay$1 as Overlay };